<template>
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Resumo do Aviso - Transporte</b>
      </div>

      <!-- Seção de Dados da Apólice -->
      <div class="box-resume">
        <div class="title-resume"> Dados da Apólice </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Corretor: </div>
              <div class="col-7 field-value">
                {{ objDTO.CorretorContacto.Nome }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> E-mail Corretor: </div>
              <div class="col-7 field-value">
                {{ objDTO.CorretorContacto.Email }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Telefone Corretor: </div>
              <div class="col-7 field-value">
                {{ objDTO.CorretorContacto.Telefone }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Ramo: </div>
              <div class="col-7 field-value">
                {{ objDTO.LinhaDeNegocio }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Unidade de Risco: </div>
              <div class="col-7 field-value">
                {{ getUnidadeRiscoDescription }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Objeto Segurado: </div>
              <div class="col-7 field-value">
                {{ getObjetoSeguradoDescription }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Cobertura: </div>
              <div class="col-7 field-value">
                {{ getCoberturaDescription }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de Dados do Embarque -->
      <div class="box-resume mt-3">
        <div class="title-resume"> Dados do Embarque </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Remetente: </div>
              <div class="col-7 field-value">
                {{ objDTO.ProcessoGDM.ProdutoEnvioContacto.Nome || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Telefone Remetente: </div>
              <div class="col-7 field-value">
                {{ objDTO.ProcessoGDM.ProdutoEnvioContacto.Telefone || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Origem: </div>
              <div class="col-7 field-value">
                {{ getLocationOrigem }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Destinatário: </div>
              <div class="col-7 field-value">
                {{ objDTO.ProcessoGDM.ProdutoRecebidoContacto.Nome || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Destino: </div>
              <div class="col-7 field-value">
                {{ getLocationDestino }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Destino (Morada): </div>
              <div class="col-7 field-value">
                {{ objDTO.ProcessoGDM.ProdutoRecebidoContacto.Morada || '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Valor Declarado: </div>
              <div class="col-7 field-value">
                {{ formatCurrency(objDTO.EmbarqueTransporte.ValorDeclarado) }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Fatura / Nº Fiscal: </div>
              <div class="col-7 field-value">
                {{ objDTO.EmbarqueTransporte.FaturaNr || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Nº Conhecimento: </div>
              <div class="col-7 field-value">
                {{ objDTO.EmbarqueTransporte.NumeroConhecimento || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Manifesto: </div>
              <div class="col-7 field-value">
                {{ objDTO.EmbarqueTransporte.Manifesto || '-' }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Data do Embarque: </div>
              <div class="col-7 field-value">
                {{ formatDate(objDTO.EmbarqueTransporte.DataEmbarque) }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Mercadoria: </div>
              <div class="col-7 field-value">
                {{ getMercadoriaDescription }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de Dados do Sinistro -->
      <div class="box-resume mt-3">
        <div class="title-resume"> Dados do Sinistro </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Data do Aviso: </div>
              <div class="col-7 field-value">
                {{ formatDate(objDTO.Sinistro.DataAviso) }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Hora do Aviso: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.HoraAviso || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Data do Sinistro: </div>
              <div class="col-7 field-value">
                {{ formatDate(objDTO.Sinistro.SinistroData) }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Hora do Sinistro: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroHora || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Local: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroMorada }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Nº: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroMoradaNrPorta }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Complemento: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroMoradaComplemento || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Bairro: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroFreguesiaDescription || '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> País: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroPaisDescricao || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Estado: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroDistritoDescripton || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Cidade: </div>
              <div class="col-7 field-value">
                {{ objDTO.Sinistro.SinistroConcelhoDescription || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Natureza: </div>
              <div class="col-7 field-value">
                {{ getEventoDescription }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Estimativa Prejuízo: </div>
              <div class="col-7 field-value">
                {{ formatCurrency(objDTO.Veiculo.ValorEstimadoReparacao) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <div class="field-label mb-1"> Descrição da Ocorrência: </div>
            <div class="field-value-large">
              {{ objDTO.Sinistro.SinistroDescricao }}
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de Dados do Transporte -->
      <div v-if="objDTO.Transporte" class="box-resume mt-3">
        <div class="title-resume"> Dados do Motorista e Veículo </div>

        <!-- Motorista -->
        <div class="resume-section-title"> Motorista </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Nome do Motorista: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Motorista.Nome || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Telefone do Motorista: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Motorista.Telefone || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> CPF do Motorista: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Motorista.CPF || '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Placa do Veículo: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Veiculo.Placa || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Marca/Modelo: </div>
              <div class="col-7 field-value">
                {{ getVeiculoMarcaModelo }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Tipo de Dano: </div>
              <div class="col-7 field-value">
                {{ getTipoDanoDescription }}
              </div>
            </div>
          </div>
        </div>

        <!-- Veículo -->
        <div class="resume-section-title mt-3"> Veículo </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Placa: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Veiculo.Placa || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Marca/Modelo: </div>
              <div class="col-7 field-value">
                {{ getVeiculoMarcaModelo }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Ano: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Veiculo.Ano || '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Tipo: </div>
              <div class="col-7 field-value">
                {{ getTipoVeiculoDescription }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Cor: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Veiculo.Cor || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Rastreamento -->
        <div class="resume-section-title mt-3"> Rastreamento </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-1">
              <div class="col-5 field-label"> Possui Rastreador: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.PossuiRastreador ? 'Sim' : 'Não' }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="objDTO.Transporte.PossuiRastreador" class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Empresa: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.EmpresaRastreamento || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Tipo Equipamento: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.TipoEquipamento || '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Telefone: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.TelefoneRastreamento || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Veículo Localizado: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.VeiculoLocalizado ? 'Sim' : 'Não' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Informações Adicionais -->
        <div class="resume-section-title mt-3"> Informações Adicionais </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Modalidade: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.Modalidade || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Gerenciadora de Risco: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.GerenciadoraRisco || '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Nº da Liberação: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.NumeroLiberacao || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Boletim de Ocorrência -->
        <div class="resume-section-title mt-3"> Boletim de Ocorrência </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-1">
              <div class="col-5 field-label"> Foi Registrado B.O.: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.PossuiBO ? 'Sim' : 'Não' }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="objDTO.Transporte.PossuiBO" class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Número do B.O.: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.NumeroBO || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Data do B.O.: </div>
              <div class="col-7 field-value">
                {{ formatDate(objDTO.Transporte.DataBO) }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Delegacia: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.DelegaciaBO || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Cidade: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.CidadeBO || '-' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Danos à Mercadoria -->
        <div class="resume-section-title mt-3"> Danos à Mercadoria </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-1">
              <div class="col-5 field-label"> Possui Danos à Mercadoria: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.PossuiDanosMercadoria ? 'Sim' : 'Não' }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="objDTO.Transporte.PossuiDanosMercadoria" class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Tipo de Dano: </div>
              <div class="col-7 field-value">
                {{ getTipoDanoDescription }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Percentual de Dano: </div>
              <div class="col-7 field-value">
                {{ objDTO.Transporte.PercentualDanoMercadoria }}%
              </div>
            </div>
          </div>
        </div>
        <div v-if="objDTO.Transporte.PossuiDanosMercadoria" class="row mt-2">
          <div class="col-12">
            <div class="field-label mb-1"> Descrição dos Danos: </div>
            <div class="field-value-large">
              {{ objDTO.Transporte.DescricaoDanosMercadoria || '-' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de Dados da Vistoria -->
      <div class="box-resume mt-3">
        <div class="title-resume"> Dados da Vistoria </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Local: </div>
              <div class="col-7 field-value">
                {{ objDTO.Vistoria.VistoriaLocal.Morada }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Nº: </div>
              <div class="col-7 field-value">
                {{ objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Complemento: </div>
              <div class="col-7 field-value">
                {{ objDTO.Vistoria.Obs || '-' }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Localização: </div>
              <div class="col-7 field-value">
                {{ getVistoriaLocation }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row mb-1">
              <div class="col-5 field-label"> Contato: </div>
              <div class="col-7 field-value">
                {{ objDTO.Vistoria.VistoriaLocal.Nome }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> Telefone: </div>
              <div class="col-7 field-value">
                {{ objDTO.Vistoria.VistoriaLocal.Telemovel }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5 field-label"> E-mail: </div>
              <div class="col-7 field-value">
                {{ objDTO.Vistoria.VistoriaLocal.Email || '-' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões no final do formulário -->
      <div class="row mt-5 mb-3">
        <div class="col-12 d-flex justify-content-end">
          <button class="button-base-small btn-gray font-small mx-2" @click="voltar">
            Voltar
          </button>
          <button
            class="button-base-small btn-green font-small mx-2"
            :disabled="isSubmitting"
            @click="finishAviso"
          >
            {{ isSubmitting ? 'Enviando...' : 'Concluir Aviso' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Swal from 'sweetalert2';
  import { createAviso } from '../../api/formMethods';
  import { handleAberturaResponseWithUploadDocuments } from '../../utils/helpers';
  import { AREA_NEGOCIO } from '../../utils/constants';

  export default {
    name: 'ResumeTransporte',
    props: {
      objDTO: {
        type: Object,
        required: true
      },
      coverages: {
        type: Array,
        default: () => []
      },
      events: {
        type: Array,
        default: () => []
      },
      riskUnits: {
        type: Array,
        default: () => []
      },
      insuranceObjects: {
        type: Array,
        default: () => []
      },
      mercadorias: {
        type: Array,
        default: () => []
      },
      tiposVeiculo: {
        type: Array,
        default: () => []
      },
      tiposDano: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        isSubmitting: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters(['getOperationData']),
      getUnidadeRiscoDescription() {
        if (!Array.isArray(this.riskUnits)) {
          return '-';
        }
        const unidadeRisco = this.riskUnits.find(
          item => item.RiskUnitId === this.objDTO.Apolice.UnidadeDeRiscoExternalId
        );
        return unidadeRisco ? unidadeRisco.Description : '-';
      },
      getObjetoSeguradoDescription() {
        if (!Array.isArray(this.insuranceObjects)) {
          return '-';
        }
        const objetoSegurado = this.insuranceObjects.find(
          item => item.InsuranceObjectId === this.objDTO.Apolice.ObjectoSeguradoExternalId
        );
        return objetoSegurado ? objetoSegurado.Description : '-';
      },
      getCoberturaDescription() {
        if (!Array.isArray(this.coverages)) {
          return '-';
        }
        const cobertura = this.coverages.find(
          item => item.GisCoverageId === this.objDTO.Apolice.ApoliceCoberturaId
        );
        return cobertura ? cobertura.Description : '-';
      },
      getEventoDescription() {
        if (!Array.isArray(this.events)) {
          return '-';
        }
        const evento = this.events.find(e => e.Id === this.objDTO.Sinistro.Evento);
        return evento ? evento.Description : '-';
      },
      getMercadoriaDescription() {
        if (!Array.isArray(this.mercadorias)) {
          return '-';
        }

        const mercadoria = this.mercadorias.find(
          item => item.Id === this.objDTO.EmbarqueTransporte.Mercadoria
        );
        return mercadoria ? mercadoria.Description : '-';
      },
      getLocationOrigem() {
        const paisOrigem = this.objDTO.EmbarqueTransporte.PaisOrigem
          ? this.objDTO.EmbarqueTransporte.PaisOrigem === 3
            ? 'Brasil'
            : 'Outro País'
          : '';

        let location = paisOrigem;

        if (this.objDTO.EmbarqueTransporte.EstadoOrigem) {
          location += `, ${this.objDTO.EmbarqueTransporte.EstadoOrigemDescription || ''}`;
        }

        if (this.objDTO.EmbarqueTransporte.CidadeOrigem) {
          location += `, ${this.objDTO.EmbarqueTransporte.CidadeOrigemDescription || ''}`;
        }

        return location || '-';
      },
      getLocationDestino() {
        const paisDestino = this.objDTO.EmbarqueTransporte.PaisDestino
          ? this.objDTO.EmbarqueTransporte.PaisDestino === 3
            ? 'Brasil'
            : 'Outro País'
          : '';

        let location = paisDestino;

        if (this.objDTO.EmbarqueTransporte.EstadoDestino) {
          location += `, ${this.objDTO.EmbarqueTransporte.EstadoDestinoDescription || ''}`;
        }

        if (this.objDTO.EmbarqueTransporte.CidadeDestino) {
          location += `, ${this.objDTO.EmbarqueTransporte.CidadeDestinoDescription || ''}`;
        }

        return location || '-';
      },
      getSinistroLocation() {
        const pais = this.objDTO.Sinistro.SinistroPaisDescricao || '';
        const estado = this.objDTO.Sinistro.SinistroDistritoDescripton || '';
        const cidade = this.objDTO.Sinistro.SinistroConcelhoDescription || '';
        const bairro = this.objDTO.Sinistro.SinistroFreguesiaDescription || '';

        let location = pais;
        if (estado) {
          location += `, ${estado}`;
        }
        if (cidade) {
          location += `, ${cidade}`;
        }
        if (bairro) {
          location += `, ${bairro}`;
        }

        return location || '-';
      },
      getVistoriaLocation() {
        const pais = this.objDTO.Vistoria.VistoriaLocal.PaisDescription || '';
        const estado = this.objDTO.Vistoria.VistoriaLocal.DistritoDescription || '';
        const cidade = this.objDTO.Vistoria.VistoriaLocal.ConcelhoDescription || '';
        const bairro = this.objDTO.Vistoria.VistoriaLocal.FreguesiaDescription || '';

        let location = pais;
        if (estado) {
          location += `, ${estado}`;
        }
        if (cidade) {
          location += `, ${cidade}`;
        }
        if (bairro) {
          location += `, ${bairro}`;
        }

        return location || '-';
      },
      getVeiculoMarcaModelo() {
        if (!this.objDTO.Transporte || !this.objDTO.Transporte.Veiculo) {
          return '-';
        }

        const marca = this.objDTO.Transporte.Veiculo.Marca || '';
        const modelo = this.objDTO.Transporte.Veiculo.Modelo || '';

        if (marca && modelo) {
          return `${marca} / ${modelo}`;
        } else if (marca) {
          return marca;
        } else if (modelo) {
          return modelo;
        }

        return '-';
      },
      getTipoVeiculoDescription() {
        if (!this.objDTO.Transporte || !this.objDTO.Transporte.Veiculo) {
          return '-';
        }

        if (!Array.isArray(this.tiposVeiculo)) {
          return '-';
        }

        const tipoVeiculo = this.tiposVeiculo.find(
          tipo => tipo.Id === this.objDTO.Transporte.Veiculo.Tipo
        );

        return tipoVeiculo ? tipoVeiculo.Description : '-';
      },
      getTipoDanoDescription() {
        if (!this.objDTO.Transporte || !this.objDTO.Transporte.TipoDanoMercadoria) {
          return '-';
        }

        if (!Array.isArray(this.tiposDano)) {
          return '-';
        }

        const tipoDano = this.tiposDano.find(
          tipo => tipo.Id === this.objDTO.Transporte.TipoDanoMercadoria
        );

        return tipoDano ? tipoDano.Description : '-';
      }
    },
    methods: {
      voltar() {
        this.$emit('back', 1);
      },
      async finishAviso() {
        this.isSubmitting = true;
        this.loading = true;
        try {
          // Ensure FormAvisoId is set correctly
          this.objDTO.FormAvisoId = 13;

          // CORREÇÃO CRÍTICA: O valor ApoliceCoberturaId está causando erro de conversão para Int32
          if (this.objDTO.Apolice && this.objDTO.Apolice.ApoliceCoberturaId) {
            const coverageId = this.objDTO.Apolice.ApoliceCoberturaId;
            console.log(`Verificando ApoliceCoberturaId: ${coverageId} (${typeof coverageId})`);

            // Verificar se o valor é maior que o limite Int32
            if (typeof coverageId === 'number' || !isNaN(Number(coverageId))) {
              const numValue = Number(coverageId);
              if (numValue > 2147483647) {
                console.warn(
                  `ApoliceCoberturaId ${coverageId} excede o valor máximo de Int32. Usando valor seguro.`
                );
                // Substituir por um valor seguro dentro do limite Int32
                this.$set(this.objDTO.Apolice, 'ApoliceCoberturaId', '1');
              } else {
                // Garantir que seja uma string para evitar problemas de precisão
                this.$set(this.objDTO.Apolice, 'ApoliceCoberturaId', String(numValue));
              }
            }
          }

          // Log de depuração após correção
          console.log(
            'Enviando dados com ApoliceCoberturaId:',
            this.objDTO.Apolice.ApoliceCoberturaId
          );

          const res = await createAviso(this.objDTO, this.coverages);
          handleAberturaResponseWithUploadDocuments(res, AREA_NEGOCIO.Transporte);
        } catch (e) {
          console.error(e);
          Swal.fire({
            title: 'Erro',
            text: `Ocorreu um erro ao finalizar o aviso: ${e.message || e}`,
            icon: 'error'
          });
        } finally {
          this.loading = false;
          this.isSubmitting = false;
        }
      },
      formatDate(date) {
        if (!date) {
          return '-';
        }

        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) {
          return '-';
        }

        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();

        return `${day}/${month}/${year}`;
      },
      formatCurrency(value) {
        if (value === null || value === undefined) {
          return 'R$ 0,00';
        }

        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(value);
      }
    }
  };
</script>

<style scoped>
  .box-resume {
    background-color: #f9f9f9;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
  }

  .box-resume > .row {
    padding: 16px;
  }

  .title-text {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 1.2em;
    margin-bottom: 16px;
  }

  .title-text::after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: #e0e0e0;
    margin-left: 15px;
  }

  .title-resume {
    font-weight: bold;
    font-size: 1.1em;
    margin-bottom: 16px;
    color: white;
    background-color: rgb(0, 0, 143);
    padding: 8px 12px;
  }

  .title-resume + .row {
    padding: 16px;
  }

  .field-label {
    font-weight: 700;
    color: #333;
  }

  .field-value {
    white-space: normal;
    word-break: break-word;
  }

  .field-value-large {
    border-radius: 4px;
    padding: 8px;
    min-height: 60px;
    white-space: pre-line;
  }

  .resume-section-title {
    font-weight: bold;
    font-size: 1.1em;
    margin-bottom: 16px;
    color: #333;
    border-bottom: 1px solid #e0e0e0;
    padding: 16px;
    padding-bottom: 8px;
  }
</style>
